<template>
  <div class="JingLuo-index bg-grey">
    <div class="content-width">
        <!-- 上方按钮 -->
        <el-row class="button-group more-search">
          <el-col :span="18" style="text-align: left">
            <el-button
              size="small"
              icon="el-icon-search"
              class="more-search-css"
              @click="searchB()"
            ></el-button>
            <el-input
              placeholder="请输入关键字搜索"
              v-model="searchInput"
              class="search-input"
              v-show="showS"
              @blur="keyWords(searchInput)"
            ></el-input>
            <el-button
              size="small"
              :class="all ? 'search-parent-selected' : 'no-checked'"
              @click="allData()"
              >全部</el-button
            >
<!--            <el-popover placement="bottom" trigger="click" v-model="visible3">-->
<!--              <el-row class="child-button-group text-center">-->
<!--                 <el-button size="small" @click="jingluo()" class="more-search-css">经络</el-button>-->
<!--                <el-button-->
<!--                  size="small"-->
<!--                  @click="xuewei()"-->
<!--                  class="more-search-css"-->
<!--                  >穴位</el-button-->
<!--                >-->
<!--              </el-row>-->
<!--              <el-button slot="reference" class="more-search-css">-->
<!--                经络/穴位-->
<!--                <i class="el-icon-arrow-down"></i>-->
<!--              </el-button>-->
<!--            </el-popover>-->
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <!-- 左边经络列表 -->
          <el-col :span="18" class="bookList clearfix">
            <el-row
              class="left-list"
              v-for="(item, index) in jingluoList"
              :key="index"
              :gutter="20"
            >
              <el-col :span="7">
                <div
                  class="block img-outer shou"
                  @click="jingluoD(item.meridiansId)"
                >
                  <!-- <img :src="$store.state.imgUrl+item.jltj" alt style="width:100%" /> -->
                  <!-- 轮播图 -->
                  <el-carousel class="top-carousel top-carousel-box">
                    <el-carousel-item
                      v-for="(items, indexs) in item.jltj"
                      :key="indexs"
                      class="carousel-img-outer common-img-outer"
                      v-if="items"
                    >
                      <!-- <a :href="items" > -->
                      <img
                        :src="$store.state.imgUrl+items"
                        alt
                        style="width: 100%"
                        v-if="indexs == '0'"
                      />
                      <!-- </a> -->
                      <img :src="$store.state.imgUrl+items" alt v-else style="width: 100%" />
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <div class="imgTip">图片仅供学习参考，侵权请联系下架</div>
              </el-col>
              <el-col :span="17">
                <div class="name">{{ item.meridiansName }}</div>
                <div class="introduce">{{ item.intro }}</div>
                <div class="tag-list">
                  <el-tag
                    type="info"
                    v-for="(item1, index1) in item.acupointList"
                    :key="index1"
                    class="shou"
                    @click="xueweiD(item1.id, item.meridiansId)"
                    >{{ item1.name }}</el-tag
                  >
                </div>
                <div class="detail-btn" @click="jingluoD(item.meridiansId)">
                  查看详情
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="view-more" @click="moreDate()" v-show="xianshi">
                  查看更多
                </div>
              </el-col>
            </el-row>
          </el-col>

          <!-- 右边收藏列表 -->
          <el-col :span="6">
            <el-row style="margin-bottom: 10px">
              <el-col>
                <div @click="goXw" style="cursor:pointer;">
                  <img src="../assets/img/xueweititle.png" alt="">
                </div>
              </el-col>
              <el-col>
                <div class="right-list">
                  <div class="collection-title">
                    <img src="../assets/img/book.png" alt /> 腧穴的定位
                  </div>
                  <div class="list-one">
                    <div
                      @click="shuxueD(item.id)"
                      v-for="(item, index) in shuXueList"
                      :key="index"
                    >
                      {{ limitMaxWords(12, item.name) }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" class="adv-wrap">
                <div
                  class="common-img-outer setPositon listdetail-adver-outer-img"
                  v-for="(item, index) in jingxueAdverList"
                  :key="index"
                >
                  <a :href="item.urlLink">
                    <img :src="$store.state.imgUrl+item.urlImage" alt style="width: 100%" />
                    <span class="adver-words-tip" v-if="item.urlImage">{{
                      adverWordsTip
                    }}</span>
                  </a>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "JingLuoIndex",
  data() {
    return {
      adverList: [], //轮播图
      jingluoList: [], //经络列表
      searchInput: "", //文本框搜索内容
      showS: false, //搜索框不显示
      visible3: false, //切换经络穴位弹出层显示与否
      inputVisible: false,
      all: true,
      inputValue: "",
      seachButton: [
        {
          name: "归属经络",
        },
        {
          name: "归属部位",
        },
      ],
      xianshi: true,
      //经络图片
      imgList: [
        {
          url: require("../assets/img/jingluo.jpg"),
        },
      ],
      advList: [
        {
          url: require("../assets/img/32.png"),
        },
        {
          url: require("../assets/img/32.png"),
        },
      ],
    };
  },
  methods: {
    goXw(){
      this.$router.push({
        path: "/xueWeiIndex"
      });
    },
    //穴位详情
    xueweiD(id, meridiansId) {
      this.$router.push({
        path: "/xueWeiDetail",
        query: { id: id, meridiansId: meridiansId },
      });
    },
    //经络详情
    jingluoD(id) {
      this.$router.push({
        path: "/JingLuoDetail",
        query: { id: id },
      });
    },
    //腧穴详情
    shuxueD(id) {
      this.$router.push({
        path: "/shuxueDetail",
        query: { id: id },
      });
    },
    //搜索按钮
    searchB() {
      let that = this;
      if (that.showS) {
        that.showS = false;
      } else {
        that.showS = true;
      }
    },
    //全部
    allData() {
      let that = this;
      that.searchInput = "";
      that.all = true;
      that.pageInfo1.pageNum = 1;
      that.jingluoList = [];
      that.getList("");
    },
    jingluo() {
      this.visible3 = false;
      this.$router.push({
        path: "/JingLuoIndex",
      });
    },
    xuewei() {
      this.visible3 = false;
      this.$router.push({
        path: "/xueWeiIndex",
      });
    },
    //查看更多数据
    moreDate() {
      let that = this;
      that.pageInfo1.pageNum++;
      that.getList(that.searchInput);
    },
    //searchInput搜索框,gsjl归属经络,gsbw归属部位
    getList(searchInput) {
      let that = this;
      console.log("文本框关键字:" + searchInput);

      let url = "/jlxw/meridians/page";
      let parmas = {
        pageNum: that.pageInfo1.pageNum,
        pageSize: that.pageInfo1.pageSize,
        name: searchInput,
      };
      that.$http
        .post(url, parmas)
        .then((res) => {
          if (res.data.code == 200) {
            let jingluoList1 = [];
            jingluoList1 = res.data.data.list.map((item, index) => {
              let urls = [];
              if (item.jltj) {
                if (item.jltj.charAt(0) === ',') {
                  item.jltj = item.jltj.substring(1);
                }
                if (item.jltj.charAt(item.jltj.length - 1) === ',') {
                  item.jltj = item.jltj.slice(0, -1);
                }
                urls = item.jltj.split(",");
              } else {
                urls = [];
              }
              // 字母排序
              // item.acupointList.sort((x,y) => {
              //   return x['pinyin'].localeCompare(y['pinyin'])
              // })
              return {
                meridiansId: item.id,
                jltj: urls,
                meridiansName: item.name,
                acupointList: item.acupointList,
              };
            });
            // if (jingluoList1.jltj) {
            //   jingluoList1.jltj = jingluoList1.jltj.split(",");
            // }
            if (jingluoList1.length == 0) {
              that.$message({
                message: "没有更多信息了",
                type: "success",
              });
              that.xianshi = false;
            }
            //将得到的数据合并到上一次的数组中
            that.jingluoList = that.jingluoList.concat(jingluoList1);
            // console.log(that.jingluoList, "that.jingluoList");
          } else {
            that.$message.error(res.message);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //searchInput搜索框
    keyWords(searchInput) {
      let that = this;
      that.all = false;
      that.pageInfo1.pageNum = 1;
      that.jingluoList = [];
      that.getList(searchInput);
    },
  },
  created() {
    let that = this;
    that.getList();
    that.getShuxueList();
    that.getPositionAdver(5, 3);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgTip{
  font-size:12px;
  color: #bbb;
}
.el-carousel img {
  width: 100%;
  /* height: 100%; */
}
.el-carousel--horizontal {
  width: 100%;
}

.img-outer {
  width: 100%;
  height: 240.41px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.list-one {
  height: 232px;
  overflow: auto;
}

.qd-btn-group {
  text-align: center;
  padding: 10px 0px 0px;
  margin-top: 20px;
  border-top: 1px dotted #888888;
}
.qd-btn-group {
  text-align: center;
}
.button-group .el-button {
  padding: 9px 20px;
}

.left-list {
  margin-bottom: 30px;
}
.detail-btn {
  display: block;
  width: 120px;
  height: 32px;
  line-height: 32px;
  background-color: #f64420;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.tag-list {
  box-sizing: border-box;
  padding: 10px 10px 10px 0px;
  display: flex;
  flex-wrap:wrap ;
  align-items: center;
}
.el-tag+.el-tag{
  margin-left: 0px!important;
}
.el-tag {
  height: 25px;
  width: 62.5px;
  text-align: center;
  line-height: 25px;
  margin-right: 10px;
  cursor: pointer;
}
.el-tag:last-child{
  margin-right: auto;
}
.introduce {
  font-size: 14px;
  line-height: 24px;
  color: #666666;
  margin-top: 20px;
}

.left-list {
  padding: 20px 10px;
  background-color: white;
  /* margin-right: 40px; */
}
/* .left-list .el-col-4 {
  margin-right: 45px;
} */
.name-div {
  width: 24px;
  height: 63px;
  padding: 6px 0px;
  background-color: #ffffff;
  border: solid 1px #6c6b69;
  font-size: 13px;
  line-height: 17px;
  color: #444444;
  position: absolute;
  top: 25px;
  left: 33px;
  text-align: center;
  cursor: pointer;
}

.list-two > div {
  width: 100px;
  height: 125px;
  background-repeat: no-repeat;
  float: left;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
}
.list-two > div:nth-child(1) {
  margin-right: 10px;
  background-image: url("../assets/img/iconbook1.png");
}
.list-two > div:nth-child(2) {
  background-image: url("../assets/img/iconbook2.png");
}
.list-two > div:nth-child(3) {
  margin-right: 10px;
  background-image: url("../assets/img/iconbook3.png");
}
.list-two > div:nth-child(4) {
  background-image: url("../assets/img/iconbook4.png");
}

/* .contain {
  background-color: #f9f9f9;
} */
 .content-width{
  padding-top:20px ;
 }
.button-group {
  text-align: center;
  padding: 0px 0px 30px;
}

.one-book-title-box {
  width: 50px;
  height: 160px;
  padding: 20px 0px;
  background-color: #ffffff;
  border: solid 1px #6c6b69;
  font-size: 22px;
  line-height: 40px;
  letter-spacing: 4px;
  color: #444444;
  position: absolute;
  top: 67px;
  left: 82px;
  text-align: center;
}
.one-book {
  width: 272px;
  height: 340px;
  position: relative;
}
.box-card {
  background-repeat: no-repeat;
  background-image: url("../assets/img/13.png");
  margin-bottom: 20px;
}

.el-card {
  width: 272px;
  float: left;
}
.el-card:not(:last-child) {
  margin-right: 17.5px;
}
.book-detail {
  padding: 22px;
}
.book-detail .top-title {
  font-size: 18px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #333333;
}
.book-detail .author {
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 1.4px;
  color: #666666;
}
.book-detail .summary {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1.4px;
  color: #999999;
}
</style>
<style>
.top-carousel-box .el-carousel__indicators--horizontal {
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}
.top-carousel-box .el-carousel__container {
  position: relative;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/JingLuoIndex.vue